/**
 * Format date to DD/MM/YYYY
 * @param {string|Date} date - The date to format
 * @returns {string} - Formatted date
 */
export const formatDate = (date) => {
  const d = new Date(date);
  return d.toLocaleDateString('pt-BR');
};

/**
 * Format time to HH:mm
 * @param {string|Date} date - The date to format
 * @returns {string} - Formatted time
 */
export const formatTime = (date) => {
  const d = new Date(date);
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};